// extracted by mini-css-extract-plugin
module.exports = {"root":"TermsOfService_root__1i7UM","lastUpdated":"TermsOfService_lastUpdated__1W_do"};